/* global global, Raven */
/* eslint new-parens: 0 */
/* eslint no-new: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
// solve bootstrap import alias ^

import jQuery from 'jquery';
import 'jquery-migrate';
import 'bootstrap';
import 'bootstrap-sass/assets/javascripts/bootstrap/affix';
import Backbone from 'backbone';
import Cookies from 'js-cookie';
import anchorJS from 'anchorJS';

import { getQueryParams } from 'utils/wrappers';
import { showErrorWithSupportLink } from 'utils/messages';

import DefaultRouter from 'app/routers/default_router';
import AccountRouter from 'app/routers/account_router';

import User from 'app/models/user';

import BasicNavbarView from 'app/views/basic_navbar_view';
import LeadGatherButtonComponent from 'app/views/lead_gather_button_component';

import APIDocsPage from 'app/views/api_docs_page';
import CanadaPostAccountCallbackPage from 'app/views/canada_post_account_callback_page';
import CanadaPostAccountRegistrationPage from 'app/views/canada_post_account_registration_page';
import ScrollspyPage from 'app/views/scrollspy_page';
import UpsAccountRegistrationPage from 'app/views/ups_account_registration_page';
import USPSRateChartPage from 'app/views/usps_rate_chart_page';

import addAdroll from 'utils/adroll';

import saveAs from '../../vendor/FileSaver';

/* eslint import/prefer-default-export: 0 */
export const ERROR_STATUS_MESSAGES = {
  408: 'A request timed out (408).',
  504: 'A request timed out (504).',
};

global.saveAs = saveAs;
global.anchorJS = anchorJS;

/* eslint no-multi-assign: 0 */
global.jQuery = global.$ = jQuery;

const EasyPost = global.EasyPost = {
  Collections: {},
  Models: {},
  Routers: {},
  Utils: {},
  Views: {
    APIDocsPage,
    CanadaPostAccountCallbackPage,
    CanadaPostAccountRegistrationPage,
    ScrollspyPage,
    UpsAccountRegistrationPage,
    USPSRateChartPage,
  },
  Globals: {},

  initialize() {
    const user = new User({});
    EasyPost.Globals.currentUser = user;
    EasyPost.Globals.firstFetchComplete = false;
    user.once('sync', model => {
      Raven.setUserContext({
        id: model.get('id'),
        email: model.get('email'),
      });
    });
    user.once('sync error', () => {
      EasyPost.Globals.firstFetchComplete = true;
    });
    user.once('error', () => {
      if (!EasyPost.Globals.currentRouter || !EasyPost.Globals.currentRouter.loggedIn) {
        addAdroll();
      } // Only if not on a logged-in or otherwise sensitive page
    });

    new BasicNavbarView({ el: '#backbone_navbar', model: user }).render();
    user.fetch();

    $('a[data-target="#lead-gather-modal"], button[data-target="#lead-gather-modal"]').each((idx, el) => (
      new LeadGatherButtonComponent({ el, source: $(el).data('source'), user })
    ));

    $('body').on('shown.bs.modal', () => {
      $('.modal-dialog *:not(".daterange-picker") > div > input:visible:first').focus();
    });

    jQuery.expr.pseudos.icontains = jQuery.expr.createPseudo(arg => elem => (
      jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0
    ));

    // for signup Analytics
    const { utm_source: utmSource } = getQueryParams();
    if (utmSource) {
      if (!Cookies.get('firstTouch')) {
        Cookies.set('firstTouch', utmSource);
      }
      Cookies.set('lastTouch', utmSource);
    }

    new DefaultRouter;
    new AccountRouter;
    Backbone.ajax = (args = {}) => Backbone.$.ajax.call(
      Backbone.$,
      {
        ...args,
        error(...errorArgs) {
          const method = args.type;
          const {
            status, responseText, responseJSON, statusText,
          } = errorArgs[0];
          const errorMessage = ERROR_STATUS_MESSAGES[status];
          if (errorMessage) {
            showErrorWithSupportLink(`${errorMessage} Please try refreshing the page.`);
            Raven.captureException(`${this.url} ${method} ${status}`, {
              extra: {
                method, status, responseText, responseJSON, statusText,
              },
            });
          }
          args.error(...errorArgs);
        },
      },
    );
    Backbone.history.start({ pushState: true });
  },
};

$(EasyPost.initialize);



// WEBPACK FOOTER //
// ./app/root.js